module.exports = {
  rootPath: '/direct/',
  cdnPath: '//static.gameplus.qq.com/wap/direct/',
};



// WEBPACK FOOTER //
// ../runtime/config.js